import { useMongoAdd, useMongoDelete, useMongoUpdate } from "contexts/useMongoQuery";

const useVisitsMutations = () => {
  return {
    addVisit: useAddVisit(),
    updateVisit: useUpdateVisit(),
    deleteVisit: useDeleteVisit(),
  };
}
export default useVisitsMutations;

const useAddVisit = () => {
  const [addVisitMutation] = useMongoAdd("visits");
  const addVisit = async (visit: any) => {
    // @ts-ignore
    const { addedVisit } = await addVisitMutation({
      created: new Date(),
      updated: new Date(),
      ...visit,
    });
    return addedVisit;
  };
  return addVisit;
}

const useDeleteVisit = () => {
  const [deleteVisitMutation] = useMongoDelete("visits");

const deleteVisit = async (visit: Visit) => {
    // @ts-ignore
    const { deletedVisit } = await deleteVisitMutation({ _id: visit._id });
    return deletedVisit;
  };
  return deleteVisit;
}

export const useUpdateVisit = (completed?: () => void) => {
    const [updateDataMutation, { data, error }] = useMongoUpdate("visits", false, {}, completed);
    const updateData = async (queryValue: string | number | KV, set: { [key: string]: any }): Promise<{ updatedData: { [key: string]: any }, error?: Error }> => {
        await updateDataMutation({ _id: queryValue}, set);
        const updatedData: { [key: string]: any } = data || {}
        return { updatedData, error };
    };
    return updateData;
}